<template>
	<slick ref="slick" :options="slickOptions">
	  <Slide v-for="(item,i) in slideData" :data="item" :key="i" class="carousel-item" :type="item.type"></Slide>
	</slick>
</template>

<script>
	
	import jQuery from "jquery"
	import Slide from '@/components/Slide'
	import Slick from 'vue-slick'
	import firebase from 'firebase'
	import Vue from 'vue'

	import '../../node_modules/slick-carousel/slick/slick.css'

	window.jQuery = window.$ = jQuery

	export default {
		name: "Viewer",
		data () {
			return {
				slideData: [],
				slickOptions: {
	                slidesToShow: 1,
	                autoplay: true,
	                autoplaySpeed: 10000,
	                arrows: false,
	                fade: true,
	                pauseOnHover: false,
	                pauseOnFocus: false,
	                dots: false,
	            },
			}
		},
		components: {
			Slide,
			Slick,
		},
		methods: {
			snapshotToArray: function(snapshot) {
	            var returnArr = [];
	            snapshot.forEach(function(childSnapshot) {
	                var item = childSnapshot.val();
	                item.key = childSnapshot.key;
	                returnArr.push(item);
	            });
	            return returnArr;
	        },
	        next() {
	            this.$refs.slick.next();
	        },

	        prev() {
	            this.$refs.slick.prev();
	        },

	        reInit() {
	            console.log("here");
	            this.$nextTick(() => {
	                this.$refs.slick.reSlick();
	            });
	        }
		},
		mounted() {
			let screenID = this.$route.params.id;
			firebase.database().ref(screenID).on('value', (snapshot) => {
				this.slideData = this.snapshotToArray( snapshot );
			});
		},
		created() {
			let screenID = this.$route.params.id;
			firebase.database().ref(screenID).once('value').then( (snapshot) => {
				this.slideData = this.snapshotToArray( snapshot );
				console.log(this.slideData)
			} );



			this.$nextTick(function () {
			  this.reInit();
			});


		},
		beforeUpdate() {
		    if (this.$refs.slick) {
		        this.$refs.slick.destroy();
		    }
		},
		updated() {
		    if (this.$refs.slick && !this.$refs.slick.$el.classList.contains('slick-initialized')) {
		        this.$refs.slick.create();
		    }
		},
	}

</script>

<style scoped>
	.carousel{
		height: 100vh;
		min-height: 100vh;
	}

	.carousel-item{
		min-height:100vh;
		background-size: cover;
		background-repeat: no-repeat;
	}
</style>


// WEBPACK FOOTER //
// src/components/Viewer.vue